import React from "react";
import { CustomAccordion } from "../../components/Accordion";

const GuideLines = [
    {
        id: "1",
        summary: "AV Setup & Equipment",
    },
    {
        id: "2",
        summary: "Media & Recording Policies",
    },
    {
        id: "3",
        summary: "Stage & Presentation Setup",
    },
    {
        id: "4",
        summary: "Additional Guidelines & Special Requests",
    },
];
function EventGuidelines() {
    return (
        <div>
            {GuideLines.map((cItem) => (
                <CustomAccordion
                    key={cItem.id}
                    view="v1"
                    gutterBottom
                    summary={cItem.summary}
                    details={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget."}
                ></CustomAccordion>
            ))}
        </div>
    );
}

export default EventGuidelines;
